<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：首页>我的申报（待补充资料）</div>
      <div class="curse-btn" v-if="end == 0" @click="to(`/formsub`)">
        添加项目
      </div>
    </div>
    <div class="list-content">
      <el-steps finish-status="success">
        <el-step title="点击补充资料"></el-step>
        <el-step title="上传实施方案Word版及盖章扫描PDF版"></el-step>
        <el-step title="提交补充资料"></el-step>
      </el-steps>

      <div style="border: 1px solid #eceef0; margin: 20px 0 0 0"></div>
      <!--      approve_status 0 未提交 1 审核中 2 审核通过 3 审核驳回
      is_save 0 已提交 1 草稿-->

      <div class="item" v-for="item in list" :key="item.id">
        <div class="item-title ovHide">{{ item.project_name }}</div>
        <div class="item-time">{{ zhDate(item.create_time * 1000) }}</div>
        <div class="item-set">
          <div class="flex justify-start align-center">
            <!--            <div class="item-type grey" v-if="item.approve_status == 0">未提交</div>-->
            <!--            <div class="item-type blue" v-else>提交成功</div>-->
            <!--            <div class="item-type blue" v-if="item.approve_status == 1">提交成功</div>-->
            <div class="item-type red" v-if="item.approve_status == 3">
              初审未通过
            </div>
            <div class="item-type green" v-if="item.approve_status == 2">
              初审通过，成功入库
            </div>

            <a
              :href="item.organ_letter"
              target="_blank"
              v-if="item.organ_letter"
              class="item-look"
            >
              查看申报书
            </a>

            <a
              :href="item.word_file[0].href"
              v-if="item.word_file.length > 0"
              class="item-look"
              style="width: auto; padding: 0 10px"
            >
              实施方案（WORD版本）
            </a>

            <a
              :href="item.pdf_file[0].href"
              target="_blank"
              v-if="item.pdf_file.length > 0"
              class="item-look"
              style="width: auto; padding: 0 10px"
            >
              实施方案（PDF版本）
            </a>

            <a
              :href="item.reload_word_file[0].href"
              v-if="item.reload_word_file.length > 0"
              class="item-look"
              style="width: auto; padding: 0 10px"
            >
              实施方案（WORD版本）（补充）
            </a>

            <a
              :href="item.reload_pdf_file[0].href"
              target="_blank"
              v-if="item.reload_pdf_file.length > 0"
              class="item-look"
              style="width: auto; padding: 0 10px"
            >
              实施方案（PDF版本）（补充）
            </a>
            <!--            <a :href="item.implement_letter" target="_blank" v-if="item.implement_letter" class="item-look">查看意见书</a>-->
          </div>
          <!-- v-if="end == 0" -->
          <div class="item-btnbox">
            <!-- <router-link
              class="item-btn"
              :to="`/formSub?id=${item.id}`"
              v-if="item.approve_status != 1"
            >
              <i class="iconfont icon-redact"></i> 编辑
            </router-link> -->
            <!-- <div
              class="item-btn"
              @click="del(item.id)"
              v-if="item.approve_status == 0 || item.approve_status == 3"
            >
              <i class="iconfont icon-6shanchu-2"></i> 删除
            </div> -->
            <!-- <upload-file
              class=""
              name="organ_letter"
              accept=".pdf"
              v-if="item.project_id && item.is_save === 1"
              :params="item"
              auth
              @uploadFile="uploadFile"
            >
              <div class="item-btn" slot="upload">
                <i class="iconfont icon-shangchuan"></i> 上传pdf格式申报书
              </div>
            </upload-file> -->

            <router-link
              class="item-btn"
              :to="`/project_formsub?id=${item.id}&is_recheck=1`"
              v-if="idList.includes(item.id)"
            >
              <i class="iconfont icon-redact"></i> 提交实施方案
            </router-link>
            <!-- <upload-file
              class=""
              name="implement_letter"
              v-if="false"
              :params="item"
              auth
              @uploadFile="uploadFile"
            >
              <div class="item-btn" slot="upload">
                <i class="iconfont icon-shangchuan"></i> 上传意见书
              </div>
            </upload-file> -->
            <!-- <div
              class="item-btn"
              @click="exit(item.id)"
              v-if="item.approve_status == 1"
            >
              <i class="iconfont icon-withdraw-fill"></i> 撤回
            </div> -->
            <!-- <div
              class="item-btn"
              @click="sub(item.id)"
              v-if="item.project_id && item.is_save == 1 && item.organ_letter"
            >
              <i class="iconfont icon-shenbao"></i> 提交申报
            </div> -->
          </div>
          <!-- <div v-else class="item-btnbox">
            <router-link
              class="item-btn"
              :to="
                item.project_id
                  ? `/project_formsub?projectId=${item.id}&is_recheck=1`
                  : `/project_formsub?id=${item.id}&is_recheck=1`
              "
            >
              <i class="iconfont icon-redact"></i> 补充资料
            </router-link>
          </div> -->
        </div>
        <div class="item-feedback" v-if="item.approve_status == 3">
          驳回原因：<span>{{ item.refund_reason }}</span>
        </div>
      </div>
      <div class="page-box flex justify-center padding-top-sm">
        <el-pagination
          class="page-all margin-bottom"
          background
          @current-change="init"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  deleteProjectInfo,
  exitProjectApplication,
  getProjectApplicationList,
  save_organ_Letter,
  save_implement_letter,
  projectApprove,
  isEnd,
} from "@/api/index";
import { zhDate } from "@/tools";
import UploadFile from "@/components/UploadFile";
import { baseURL } from "@/config";
export default {
  name: "index",
  data() {
    return {
      zhDate: zhDate,
      baseURL: baseURL,
      list: [],
      page: 1,
      limit: 10,
      total: 20,
      end: 1,
      idList: [
        452, 199, 177, 214, 337, 244, 119, 432, 269, 256, 33, 317, 273, 185,
        441, 18, 311, 217, 215, 88, 193, 135, 195, 25, 260, 449, 445, 378, 252,
        20, 309, 248, 196, 254, 40, 75, 395, 65, 57, 263, 202, 220, 226, 235,
        253, 245, 329, 447, 444, 440, 370, 429, 62, 160, 159, 356, 334, 344,
        349, 305, 355, 357, 251, 325, 136, 82, 64, 338, 427, 402, 239, 394, 365,
        209, 122, 425, 145, 133, 271, 301, 268, 312, 383, 223, 228, 234, 363,
        403, 299, 437, 451, 187, 153, 154, 446, 125, 250, 101, 140, 134,
      ],
    };
  },
  computed: {
    token() {
      return this.$store.state.shzztoken;
    },
  },
  components: { UploadFile },
  created() {
    this.$emit("setActive", {
      active: 1,
    });

    this.init();
    this.isEnd();
    /**
     if (!sessionStorage.getItem("tips")) {
      this.$alert(
        '<p>通知：</p><p style="text-indent: 28px">2026年社会组织服务项目初审工作已经结束，申报项目的社会组织可以在申报系统中查询申报结果。后续市、区两级相关部门将对入库项目开展立项支持评审。需要进一步提供项目实施方案或参加项目评审会的，相关部门将电话联系。所有成功入库项目，在2026年12月31日前有效。</p>',
        "温馨提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          callback: () => {
            sessionStorage.setItem("tips", 1);
          },
        },
      );
    }
     */
  },
  methods: {
    async isEnd() {
      let _data = await isEnd();
      if (_data.code === 200) {
        this.end = _data.data;
      }
    },

    uploadFile(data) {
      // this.ruleForm[data.name].push({
      //   name: data.file.name,
      //   href: data.file.url,
      // })
      if (data.name == "implement_letter") {
        this.save_implement_letter(data.data.id, data.file.url);
      } else {
        this.save_organ_Letter(data.data.id, data.file.url);
      }
    },
    async save_organ_Letter(id, url) {
      let _data = await save_organ_Letter(id, url, 1);
      if (_data.code === 200) {
        this.$message.success("上传成功");
        this.init();
        this.sub(id);
      } else {
        this.$confirm(_data.message, "提示", {
          confirmButtonText: "去填报",
          cancelButtonText: "取消",
          type: "error",
        })
          .then(() => {
            this.$router.push({
              path: "/formsub",
              query: {
                id: id,
              },
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
        this.$message.error(_data.message);
      }
    },
    async save_implement_letter(id, url) {
      let _data = await save_implement_letter(id, url);
      if (_data.code === 200) {
        this.$message.success("上传成功");
        this.init();
      } else {
        this.$message.error(_data.message);
      }
    },

    sub(id) {
      this.$confirm("是否立即提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let _data = await projectApprove(id, 1);
        if (_data.code === 200) {
          this.$message.success(_data.message);
          this.init();
        } else {
          this.$message.error(_data.message);
        }
      });
    },

    // 获取列表
    async init() {
      let _data = await getProjectApplicationList(
        "",
        "",
        "",
        "",
        this.page,
        this.limit,
        1,
      );
      if (_data.code === 200) {
        this.list = _data.data.data;
        this.total = _data.data.total;
      } else {
        this.$message.error(_data.message);
      }
    },
    // 删除
    del(id) {
      this.$confirm("你确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let _data = await deleteProjectInfo(id);
        if (_data.code === 200) {
          this.$message.success(_data.message);
          this.init();
        } else {
          this.$message.error(_data.message);
        }
      });
    },

    // 撤回
    exit(id) {
      this.$confirm("你确定撤回吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let _data = await exitProjectApplication(id);
        if (_data.code === 200) {
          this.$message.success(_data.message);
          this.init();
        } else {
          this.$message.error(_data.message);
        }
      });
    },

    to(path) {
      this.$router.push(path);
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;

  .curse-content {
    width: 100%;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px 10px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    border: 1px solid #999999;
    background: #ffffff;
    border-radius: 20px;
    padding: 20px;
    margin-top: 15px;

    .item {
      width: 100%;
      padding: 20px 0;
      border-bottom: 1px solid #eceef0;
      .item-feedback {
        width: 100%;
        padding: 10px 15px;
        background-color: #f7f7f7;
        font-size: 14px;
        font-weight: bold;
        color: #ed3434;
        margin-top: 10px;
        span {
          color: #333333;
          font-weight: normal;
        }
      }
      .item-set {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item-btnbox {
          flex: 1;
          margin-left: 50px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .item-btn {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            font-size: 14px;
            color: #333333;
            margin-left: 20px;
            i {
              font-size: 16px;
              color: #333333;
              margin-right: 4px;
            }
          }
        }
        .item-look {
          width: 100px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          background-image: linear-gradient(90deg, #0115a6 0%, #1546c5 100%);
          margin-left: 15px;
          cursor: pointer;
          color: #ffffff;
        }
        .item-type {
          //width: 72px;
          padding: 0 10px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          &.grey {
            color: #999999;
            background-color: #f3f3f3;
          }
          &.red {
            color: #eb1d1d;
            background-color: #ffeded;
          }
          &.green {
            color: #1ea735;
            background-color: #e9f8e5;
          }
          &.blue {
            color: #3381c3;
            background-color: #e5eff8;
          }
        }
      }
      .item-time {
        width: 100%;
        font-size: 14px;
        color: #999999;
        margin: 10px 0;
      }
      .item-title {
        width: 100%;
        font-size: 16px;
        color: #333333;
      }
    }
  }
}
</style>
